.jf{pointer-events:auto;}